import { Paper, Avatar, Grid, TextField, Button } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';
import { useState, useEffect } from "react";
import { useAuth } from "../components/AuthContext";
import ErrorPaper from "../components/ErrorPaper";
import InfoPaper from "../components/InfoPaper";

type Settings = {
    default_topic: string,
};
const PensieveBaseUri = 'http://api.epensieve.com';

const SettingsPage = () => {
    const { token } = useAuth()!;
    const [settings, setSettings] = useState<Settings>({default_topic: ''});
    const [error, setError] = useState<string | null>(null);
    const [info, setInfo] = useState<string | null>(null);

    const url = `${PensieveBaseUri}/settings`;
    
    useEffect(() => {
        fetch(url, {method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((response) => {
            if (!response.ok) {
                throw new Error ('Could not load user settings. Try Refreshing or Logging out an in again.');
            }
            return response.json();
        }).then((result) => {
            setSettings({
                ...result,
            });
        }).catch((err) => {
            setError(err.message);
        });
    }, [url, token]);

    const handleSubmit = (evt: any) => {
        evt.preventDefault();
        fetch(url, {method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(settings)
        }).then((response) => {
            if (!response.ok || !response.body) {
                throw new Error('Could not update user settings. Try Refreshing or Logging out an in again.');
            }

            setInfo('Successfully saved User Settings.');
            setTimeout(() => { setInfo(null); }, 2000);
        }).catch((err) => {
            setError(err.message);
        });
    };

    const paperStyle = {
        padding: 2, 
        margin:"50px auto",
        width: { lg:600, md:500, sm:400, xs:300 },
        minWidth: { lg:600, md:500, sm:400, xs:250 },
        height: '250',
    };

    return (
        <form onSubmit={handleSubmit}>
            { (error) && <ErrorPaper error={error} /> }
            { (info)  && <InfoPaper  msg={info} /> }
            <Paper elevation={10} sx={paperStyle} >
                <Grid container alignItems={'center'} direction={'column'} spacing={1} textAlign='center' width={'inherit'} >
                    <Grid item>
                        <Avatar> <SettingsIcon fontSize="large" /> </Avatar>
                    </Grid>
                    <Grid item>
                        <h2> Configure your Pensieve </h2>
                    </Grid>
                    <Grid item width={'inherit'} >
                        <TextField label='Default Topic' value={settings.default_topic} onChange={(evt : any) => {setSettings({...settings, default_topic: evt.target.value})}} variant='standard' fullWidth />
                    </Grid>
                    <Grid item >
                        <Button sx={{marginTop:4}} type='submit' color='primary' variant='contained' fullWidth> Submit Changes </Button>
                    </Grid>
                </Grid>
            </Paper>
        </form>
    );
}

export default SettingsPage;